import EditRecurringForm from 'src/components/Forms/EditRecurringForm';
import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';

const EditRecurringModal = () => (
  <ModalBase name={MODALS.editRecurring} size={MODALS_SIZE.medium} form={FORM.get_recurring}>
    <EditRecurringForm />
  </ModalBase>
);

export default EditRecurringModal;
